__turbopack_context__.v({
  "fill": "ScrollProgressBar-module__vzDHIa__fill",
  "track": "ScrollProgressBar-module__vzDHIa__track",
  "wrap": "ScrollProgressBar-module__vzDHIa__wrap",
});
